import { configureStore } from '@reduxjs/toolkit';
import counterReducer from '../redux/counterSlice';
import technicianListColumnsReducer from '../redux/technicianListColumnsSlice';
import offerListColumnsReducer from '../redux/offerListColumnsSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    technicianListColumns: technicianListColumnsReducer,
    offerListColumns: offerListColumnsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
